import React from "react";

function Dashboard() {
  return <div>Dashboard component !! </div>;
}

export default Dashboard;
